import * as React from 'react'

function SvgRepairFailedIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M14.646 15.354 12 12.707l-2.646 2.647-.708-.707L11.293 12 8.646 9.354l.708-.708L12 11.293l2.646-2.647.708.708L12.707 12l2.646 2.646-.707.708Z"
        fill="#E91630"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 7a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"
        fill="#E91630"
      />
    </svg>
  )
}

export default SvgRepairFailedIcon
